import FormikAutoComplete from "common/components/FormikFields/FormikAutoComplete"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import { DEFAULT_COUNTRY_SELECTED, countries } from "common/constants/countries"
import useRazonSocialAndCif from "common/hooks/useRazonSocialAndCif"
import useSearchEmpresa from "common/hooks/useSearchEmpresa"
import ReactFlagsSelect from "react-flags-select"
import { useTranslation } from "react-i18next"

const DatosEmisorForm = ({ setFieldValue, values }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { searchEmpresaByNif } = useSearchEmpresa({})
  const {
    razonesSociales,
    cifs,
    getByCifOrRazonSocial,
    getRazonSocialByCif,
    getCifByRazonSocial,
    getEmpresaIDByCif,
    getEmpresaIDByRazonSocial,
  } = useRazonSocialAndCif()

  const handleOnSelectRazonSocial = async (e: $TSMigrationFixMe) => {
    const cif = getCifByRazonSocial(e.value)
    const id = getEmpresaIDByRazonSocial(e.value)

    setFieldValue("libradorRazonSocial", e.value)
    setFieldValue("libradorNif", cif)
    setFieldValue("libradorID", id)
    searchEmpresaByNif(cif)
  }

  const handleOnSelectCif = (e: $TSMigrationFixMe) => {
    setTimeout(() => setFieldValue("libradorNif", e.value), 10) // TODO: Revisar porque existe el setTimeout
    const razonSocial = getRazonSocialByCif(e.value)
    const id = getEmpresaIDByCif(e.value)

    setFieldValue("libradorID", id)
    setFieldValue("libradorRazonSocial", razonSocial)
    searchEmpresaByNif(e.value)
  }

  return (
    <>
      <div className='text-left p-fluid p-formgrid p-grid'>
        <div className='p-field p-col '>
          <label htmlFor='libradorRazonSocial'>{t("ocr.nameLabel")}</label>

          {values.libradorPais === DEFAULT_COUNTRY_SELECTED ? (
            <FormikAutoComplete
              id='libradorRazonSocial'
              name='libradorRazonSocial'
              completeMethod={(query: $TSMigrationFixMe) =>
                getByCifOrRazonSocial("razonSocial", query)
              }
              suggestions={razonesSociales}
              onSelect={handleOnSelectRazonSocial}
              onChange={handleOnSelectRazonSocial}
            />
          ) : (
            <FormikInputText
              id='libradorRazonSocial'
              name='libradorRazonSocial'
            />
          )}
        </div>

        <div className='p-field p-col selected-country-mix-cif'>
          <label htmlFor='libradorNif'>{t("ocr.nifLabel")}</label>

          <ReactFlagsSelect
            name='libradorPais'
            className='selected-country-mix-cif__select-country-field'
            onSelect={(code) => setFieldValue("libradorPais", code)}
            searchable
            selected={values.libradorPais || DEFAULT_COUNTRY_SELECTED}
            customLabels={countries}
            // @ts-expect-error TS(2322): Type 'DefaultTFuncReturn' is not assignable to typ...
            searchPlaceholder={t("ocr.placeholderSearch")}
            showSelectedLabel={false}
          />

          <FormikAutoComplete
            id='libradorNif'
            name='libradorNif'
            className='selected-country-mix-cif__input-cif-field'
            isCif
            completeMethod={(query: $TSMigrationFixMe) =>
              getByCifOrRazonSocial("cif", query)
            }
            suggestions={cifs}
            onSelect={handleOnSelectCif}
            onChange={handleOnSelectCif}
          />
        </div>
      </div>

      {/* TODO: Averiguar para exite el input oculto */}
      <input
        type='text'
        autoComplete='on'
        value=''
        style={{
          display: "none",
          opacity: 0,
          position: "absolute",
          left: "-100000px",
        }}
        readOnly
      />
    </>
  )
}

export default DatosEmisorForm
